import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('dnd-cover', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      let $element = $(element);

      $element.addClass('foquz-dnd-cover');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
